// Action Names
import { type LocationChangeAction } from "../../_Bootstrap/RoutingAndStore";
import { type OpenCustomerDisplayAction } from "../CustomerDisplay/CustomerDisplayActions";
import { type UserLogoutAction } from "../Users/UserActions";
import { type NavigationClickAction } from "./NavigationActions";

export const LAYOUT_TOGGLE_MENU = "LAYOUT_TOGGLE_MENU";
export const LAYOUT_BODY_CLICK = "LAYOUT_BODY_CLICK";
export const LAYOUT_USER_MENU_TOGGLE = "LAYOUT_USER_MENU_TOGGLE";
export const LAYOUT_NOTIFICATIONS_TOGGLE = "LAYOUT_NOTIFICATIONS_TOGGLE";
export const LAYOUT_QUICK_MENU_TOGGLE = "LAYOUT_QUICK_MENU_TOGGLE";
export const LAYOUT_SYNCHRONISE_TOGGLE = "LAYOUT_SYNCHRONISE_TOGGLE";
export const LAYOUT_AUDIO_TOGGLE = "LAYOUT_AUDIO_TOGGLE";
export const BODY_DISPLAY_OVERLAY = "BODY_DISPLAY_OVERLAY";
export const BODY_HIDE_OVERLAY = "BODY_HIDE_OVERLAY";
export const BODY_DISPLAY_LOADING = "BODY_DISPLAY_LOADING";
export const BODY_HIDE_LOADING = "BODY_HIDE_LOADING";
export const HEADER_DISPLAY_OVERLAY = "HEADER_DISPLAY_OVERLAY";
export const PAGE_FOCUS_LOST = "PAGE_FOCUS_LOST";
export const PAGE_FOCUS_GAINED = "PAGE_FOCUS_GAINED";

export interface ToggleMenuAction {
    type: typeof LAYOUT_TOGGLE_MENU;
}

export interface BodyClickAction {
    type: typeof LAYOUT_BODY_CLICK;
}

export interface UserMenuToggleAction {
    type: typeof LAYOUT_USER_MENU_TOGGLE;
}

export interface NotificationToggleAction {
    type: typeof LAYOUT_NOTIFICATIONS_TOGGLE;
}

export interface QuickMenuToggleAction {
    type: typeof LAYOUT_QUICK_MENU_TOGGLE;
}

export interface SynchroniseMenuToggleAction {
    type: typeof LAYOUT_SYNCHRONISE_TOGGLE;
}

export interface AudioMenuToggleAction {
    type: typeof LAYOUT_AUDIO_TOGGLE;
}

export interface BodyDisplayOverlayAction {
    type: typeof BODY_DISPLAY_OVERLAY;
}

export interface BodyHideOverlayAction {
    type: typeof BODY_HIDE_OVERLAY;
}

export interface DisplayLoadingAction {
    type: typeof BODY_DISPLAY_LOADING;
}

export interface HideLoadingAction {
    type: typeof BODY_HIDE_LOADING;
}

export interface HeaderDisplayOverlayAction {
    type: typeof HEADER_DISPLAY_OVERLAY;
}

export interface FocusGainedAction {
    type: typeof PAGE_FOCUS_GAINED;
}

export interface FocusLostAction {
    type: typeof PAGE_FOCUS_LOST;
}

export type LayoutActionTypes =
    ToggleMenuAction |
    BodyClickAction |
    UserMenuToggleAction |
    NotificationToggleAction |
    QuickMenuToggleAction |
    SynchroniseMenuToggleAction |
    AudioMenuToggleAction |
    BodyDisplayOverlayAction |
    BodyHideOverlayAction |
    DisplayLoadingAction |
    HideLoadingAction |
    HeaderDisplayOverlayAction |
    FocusGainedAction |
    FocusLostAction |
    UserLogoutAction |
    NavigationClickAction |
    OpenCustomerDisplayAction |
    LocationChangeAction;

export interface LayoutState {
    menu: {
        open: boolean;
    };
    body: {
        overlay: boolean;
        loading: boolean;
    };
    userMenu: {
        open: boolean;
    };
    notifications: {
        open: boolean;
    };
    quickMenu: {
        open: boolean;
    };
    synchronise: {
        open: boolean;
    };
    audio: {
        open: boolean;
    };
    focus: boolean;
}

export function displayOverlay(): BodyDisplayOverlayAction {
    return {
        type: BODY_DISPLAY_OVERLAY,
    };
}

export function hideOverlay(): BodyHideOverlayAction {
    return {
        type: BODY_HIDE_OVERLAY,
    };
}

/**
 * Show the loading screen
 * @returns {{type: string}}
 * @alias showLoading
 */
export function startLoading(): LayoutActionTypes {
    return {
        type: BODY_DISPLAY_LOADING,
    };
}

/**
 * Hide the loading screen
 * @returns {{type: string}}
 * @alias hideLoading
 */
export function stopLoading(): LayoutActionTypes {
    return {
        type: BODY_HIDE_LOADING,
    };
}

export function focusGained(): LayoutActionTypes {
    return {
        type: PAGE_FOCUS_GAINED,
    };
}

export function focusLost(): LayoutActionTypes {
    return {
        type: PAGE_FOCUS_LOST,
    };
}
